"use client";

import useFilterStore from "@/stores/order-filter.store";
import { useSearchParams } from "next/navigation";
import { useDebounce } from "primereact/hooks";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { ChangeEvent, useCallback, useEffect, useMemo } from "react";

interface SearchProps {
  searchPlaceholder?: string;
}

const SearchBox = ({ searchPlaceholder }: SearchProps) => {
  const searchParams = useSearchParams();
  const updateFilter = useFilterStore((s) => s.updateFilter);

  const initialSearchTerm = useMemo(() => {
    const search = searchParams.get("search");
    return search ? decodeURIComponent(search) : "";
  }, [searchParams]);
  const [searchTerm, debouncedSearchTerm, setSearchTerm] = useDebounce(
    initialSearchTerm,
    400,
  );
  useEffect(() => {
    updateFilter({ search: initialSearchTerm.trim() });
  }, [initialSearchTerm, updateFilter]);

  const onChangeSearch = useCallback(
    (search: string) => {
      updateFilter({ search: search.trim(), page: 1 });
    },
    [updateFilter],
  );

  useEffect(() => {
    onChangeSearch(debouncedSearchTerm);
  }, [debouncedSearchTerm, onChangeSearch]);

  return (
    <div className="p-input-icon-left w-full md:w-auto md:max-w-350">
      <IconField iconPosition="left" style={{ width: 350 }}>
        <InputIcon className="pi pi-search"> </InputIcon>
        <InputText
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setSearchTerm(e.target.value);
          }}
          className="w-full"
          tabIndex={1}
        />
        <InputIcon
          className="pi pi-times bg-white p-4 text-gray-500"
          style={{
            fontSize: 12,
            right: 8,
            padding: 4,
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            marginTop: 0,
            display: searchTerm ? "block" : "none",
          }}
          onClick={() => setSearchTerm("")}
        />
      </IconField>
    </div>
  );
};

export default SearchBox;
